<template>
  <div class="eBusiness">
    <div class="page-help content">
      <div class="title">
        <p class="sm-link">{{ $t("nav.about") }}</p>
        {{ $t("newHome.eBusinessTitle") }}
      </div>
      <div class="posts">
        <div class="p-text">
          {{ $t("newHome.eBusinessP1") }}
        </div>
        <div class="p-text">
          {{ $t("newHome.eBusinessP2") }}
        </div>
        <div class="p-text">
          {{ $t("newHome.eBusinessP3") }}
        </div>
        <div class="cards">
          <div v-for="(card, index) in cards" :key="index" class="card">
            <img :src="card.img" alt="" />
            <div class="text-card">
              {{ $t(card.text) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import card_home1 from "@/assets/newImges/card_home1.svg";
import card_home2 from "@/assets/newImges/card_home2.svg";
import card_home3 from "@/assets/newImges/card_home3.svg";
export default {
  data() {
    return {
      cards: [
        {
          img: card_home1,
          text: "newHome.eBusinessCard1"
        },
        {
          img: card_home2,
          text: "newHome.eBusinessCard2"
        },
        {
          img: card_home3,
          text: "newHome.eBusinessCard3"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.eBusiness {
  width: 100%;
  text-align: left;
  font-family: Outfit;
  padding-top: 163px;
  padding-bottom: 173px;
  background-image: url("../../assets/newImges/Ellipse 147.png") !important;
  background-repeat: no-repeat;
  background-position: 85% bottom;
  background-color: $white;

  .content {
    display: flex;
    justify-content: space-between;
    .title {
      max-width: 500px;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 64px;
      line-height: 100%;
      letter-spacing: 0%;
      .sm-link {
        color: $light-blue-600;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0%;
        margin-bottom: 28px;
      }
    }
    .posts {
      width: 733px;

      .p-text {
        font-weight: 500;
        font-style: Medium;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
        color: $blue-400;
        margin-bottom: 30px;
      }
      .cards {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;

        .card {
          box-sizing: border-box;
          width: 225px;
          height: 242px;
          opacity: 1;

          border-radius: 12px;
          padding: 28px;
          background-color: $gray-blue-400;
          transition: 0.3s;

          img {
            margin-bottom: 32px;
            // width: 24px;
            // height: 20px;
          }
          .text-card {
            font-weight: 400;
            font-style: Regular;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0%;
          }
        }
        .card:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}
@media only screen and (max-width: 1120px) {
  .eBusiness {
    width: 100%;

    padding-top: 33px;
    padding-bottom: 73px;
  }
  .content {
    flex-direction: column;
  }
  .title {
    max-width: 100% !important;
    margin-bottom: 30px;
  }
  .posts {
    width: 100% !important;
  }
}
@media only screen and (max-width: 790px) {
  .eBusiness {
    width: 100%;

    padding-top: 33px;
    padding-bottom: 73px;
    background-image: url("../../assets/newImges/Ellipse 147.png") !important;
    background-repeat: no-repeat;
    background-position: center bottom;

    .content {
      flex-direction: column;

      .title {
        max-width: 100% !important;
        margin-bottom: 30px;
        font-size: 42px;
      }
      .posts {
        width: 100% !important;
        .p-text {
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 20px;
        }

        .cards {
          align-items: center;
          justify-content: center;
          flex-direction: column !important;
          .card {
            margin-bottom: 20px;
            width: 325px;
            height: fit-content;
            opacity: 1;
            margin-right: 0;

            border-radius: 12px;
            padding: 18px;
            img {
              margin-bottom: 12px;
              // width: 24px;
              // height: 20px;
            }
            .text-card {
              font-weight: 400;
              font-style: Regular;
              font-size: 14px;
              line-height: 22px;
              letter-spacing: 0%;
            }
          }
        }
      }
    }
  }
}
</style>
